import { parseString, receiveFecha, receiveFechaFormat2, sendMultipart } from "../../../../../../../adapters/helpers"

const AparatosAdapters = {

    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idproducto || '',
                    producto: item.producto || '',
                    tipoproducto: item.tipoproducto || '',
                    rutaimagen: item.rutaimagen || '',
                    rutaproducto: item.rutaproducto || '',
                    idtienda: item.idtienda || '',
                    fechaalta: receiveFechaFormat2(receiveFecha(item.fechaalta)),
                    fechabaja: receiveFechaFormat2(receiveFecha(item.fechabaja)),
                    logidpersona: item.logidpersona || '',
                    logfecha: item.logfecha || '',
                    modelo: parseString(item.modelo || ''),
                    descripcion: parseString(item.descripcion || ''),
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                

                const items = dataTemp?.data?.map((item: any) => (this.schema(item)))

                return {
                    data: {
                        total: dataTemp?.total,
                        per_page: dataTemp?.per_page,
                        current_page: dataTemp?.current_page,
                        items
                    },
                    status: data?.status
                }
            }
        },
    },
    
}

const AparatoAdapters = {

    GET: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idevento || '',
                    idtipoevento: item.idtipoevento || '',
                    aforo: item.aforo || '',
                    creditos: item.creditos || '',
                    estado: item.estado || '',
                    nombreevento: item.nombreevento || '',
                    gratuito: parseString(typeof item.gratuito === 'boolean' ? item.gratuito : ''),
                    fechainicioinscripcion: receiveFecha(item.fechainicioinscripcion),
                    fechafininscripcion: receiveFecha(item.fechafininscripcion),
                    observaciones: item.observaciones || '',
                    fechabaja: receiveFecha(item.fechabaja),
                    eventos_fechas: item.eventos_fechas || [],
                    evento_idiomas: item.evento_idiomas || [],
                    url_imagen_listado: item.url_imagen_listado || '',
                    identidad: item.identidad || '',
                    identidadsede: item.identidadsede || '',
                    idplantillaasistencia: item.idplantillaasistencia || '',
                    reversoplantilla: item.reversoplantilla || '',
                    ruta_reverso: item.ruta_reverso || '',
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data?.data

                const items = this.schema(dataTemp)

                return {
                    data: {
                        ...items
                    },
                    status: data?.status
                }
            }
        },
    },

    POST: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    producto: item.producto || '',
                    productoidioma: item.productoidioma || '',
                    modelo: item.modelo || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    id: item.idevento || '',
                    idtipoevento: item.idtipoevento || '',
                    aforo: item.aforo || '',
                    creditos: item.creditos || '',
                    estado: item.estado || '',
                    nombreevento: item.nombreevento || '',
                    gratuito: parseString(item.gratuito),
                    fechainicioinscripcion: item.fechainicioinscripcion || '',
                    fechafininscripcion: item.fechafininscripcion || '',
                    observaciones: item.observaciones || '',
                    fechabaja: item.fechabaja,
                    identidad: item.identidad || '',
                    identidadsede: item.identidadsede || '',
                    idplantillaasistencia: item.idplantillaasistencia || '',
                    // evento_idiomas: item.evento_idiomas || [],
                    // eventos_fechas: item.eventos_fechas || [],
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    PATCH_CHANGE_ESTADO: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    estado: item.estado || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return {
                    ...items
                }
            }
        },
    },

    DELETE: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },
    },

    PATCH_IMAGEN: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    imagen: item.imagen || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return sendMultipart(items)
            }
        },
    },

    DELETE_IMAGEN: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },
    },

    POST_ARCHIVO_REVERSO: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    data: item.data,
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    reversoFile: item.reversoFile || '',
                }

                return data
            },

            adapter: function (data: any) {

                const items = this.schema(data)

                return sendMultipart(items)
            }
        },
    },

    DELETE_ARCHIVO_REVERSO: {

        receive: {

            schema: function (item: any) {

                if (!item) item = {}

                const data = {
                    message: item.message,
                    status: item.status
                }

                return data
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const items = this.schema(dataTemp)

                
                return {
                    data: items,
                    status: data?.status
                }
            }
        },
    },
}


export {
    AparatosAdapters,
    AparatoAdapters
}